// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__30j7_","loaderOuter":"PageOverlayLoader_loaderOuter__1d4uW"};